import React from "react";
import { observer, inject } from "mobx-react";
import { TablePageHeader } from "../../../components/TablePageHeader";
import { Form, Button, ButtonGroup, DropdownButton, Dropdown, Row, Col, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { STORE_CUSTOMERS } from "../../../constants";
import { CustomersStore } from "../../../stores";
import { RouteComponentProps } from "react-router-dom";

interface IProps {
    [STORE_CUSTOMERS]: CustomersStore
}
interface IState {
    currentPage: number
}

type Props = IProps & RouteComponentProps<{ page: string }>;

@inject(STORE_CUSTOMERS)
@observer
export class CustomersPage extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        const page = parseInt(this.props.match.params.page) || 1;
        this.state = {
            currentPage: page
        };
    }

    customersStore = (this.props as any)[STORE_CUSTOMERS] as CustomersStore;


    loadData = () => {
        this.customersStore.loadCustomers(this.state.currentPage);
    }

    componentDidMount() {
        this.loadData();
    }

    render() {
        return [
            <TablePageHeader header="Контрагенты" reload={this.loadData} key="1">
                <Form inline>

                    <Button type="button" size="sm" onClick={() => {
                        this.props.history.push("/clients/neweditcustomer")
                    }}>
                        <FontAwesomeIcon icon="plus" />
                        {' '}
                        Контрагент
                    </Button>
                    <Button type="button" size="sm" variant="secondary" active style={{ marginLeft: "15px" }}>
                        Фильтр
                    </Button>
                    <Form.Control size="sm" placeholder="Наим, тел, email, коммент..." style={{ marginLeft: "15px", width: "250px" }} />

                    <ButtonGroup aria-label="Инструменты" style={{ marginLeft: "15px" }} size="sm">
                        <DropdownButton size="sm" variant="secondary" as={ButtonGroup} title="Изменить" id="bg-edit-dropdown-1">
                            <Dropdown.Item eventKey="1">Провести</Dropdown.Item>
                            <Dropdown.Item eventKey="2">Копировать</Dropdown.Item>
                            <Dropdown.Item eventKey="3">Удалить</Dropdown.Item>
                        </DropdownButton>
                        <DropdownButton size="sm" variant="secondary" as={ButtonGroup} title="Статус" id="bg-status-dropdown-1">
                            <Dropdown.Item eventKey="1">В работе</Dropdown.Item>
                            <Dropdown.Item eventKey="2">Отменен</Dropdown.Item>
                            <Dropdown.Item eventKey="3">Отгружен</Dropdown.Item>
                        </DropdownButton>
                        <DropdownButton size="sm" variant="secondary" as={ButtonGroup} title="Печать" id="bg-print-dropdown-2">
                            <Dropdown.Item eventKey="1">Dropdown link</Dropdown.Item>
                            <Dropdown.Item eventKey="2">Dropdown link</Dropdown.Item>
                        </DropdownButton>
                    </ButtonGroup>
                </Form>
            </TablePageHeader>,
            <Row key="2">
                <Col sm={12}>
                    <Table striped className="table-xs" >
                        <thead>
                            <tr>
                                <th></th>
                                <th style={{ width: "300px" }}>Наименование</th>
                                <th style={{ width: "180px" }}>Создан</th>
                                <th style={{ width: "180px" }}>Телефон</th>
                                <th style={{ width: "180px" }}>Email</th>
                                <th>Адрес</th>
                                <th>Комментарий</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.customersStore.customers.map((w, index) => <tr key={index}>
                                <td></td>
                                <td>{w.name.length > 0 ? w.name : w.phone}</td>
                                {/* <td>{formatDate(w.createDate)}</td> */}
                                <td>{w.phone}</td>
                                <td>{w.email}</td>
                                <td>{w.address}</td>
                                <td>{w.comment}</td>
                            </tr>)}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        ]
    }
}